module.exports = __webpack_public_path__ + "img/photo_2023-08-31_17-34-48.26b0e896.png";